import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to check if current user has a confirmed or completed booking for a listing
 */
export function useHasConfirmedBooking(listingId: string | undefined, userId: string | null | undefined) {
  return useQuery({
    queryKey: ["confirmed-booking", listingId, userId],
    enabled: !!listingId && !!userId,
    queryFn: async () => {
      if (!listingId || !userId) return false;
      
      const { data, error } = await supabase
        .from("bookings")
        .select("id")
        .eq("listing_id", listingId)
        .eq("renter_id", userId)
        .in("status", ["confirmed", "completed"])
        .limit(1);
      
      if (error) {
        console.error("Error checking booking:", error);
        return false;
      }
      
      return (data?.length ?? 0) > 0;
    },
  });
}
